import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { environment } from 'src/environments/environment';
import { CrudService } from 'src/app/services/crud.service';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { DxPopupComponent, DxDataGridComponent, DxDataGridModule, DxButtonModule, DxPopupModule, DxLoadPanelModule, DxTagBoxModule } from 'devextreme-angular';
import { RebateNames } from 'src/app/models/rebate-names.model';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { CostServiceService } from 'src/app/services/cost-service.service';
import { Product } from 'src/app/models/product.model';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { CopyCorePricingComponent } from '../copy-core-pricing/copy-core-pricing.component';
import { PromotionRebatesComponent } from '../promotion-rebates/promotion-rebates.component';
import { ProductSelectionComponent } from 'src/app/product-selection/product-selection.component';
import { BuyingGroups } from 'src/app/models/buying-groups.model';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';

@Component({
    selector: 'app-core-range-details',
    templateUrl: './core-range-details.component.html',
    styleUrls: ['./core-range-details.component.css'],
    imports: [ CommonModule, NgClass, DxDataGridModule, DxButtonModule, DxPopupModule, DxLoadPanelModule, DxTagBoxModule,
      CopyCorePricingComponent,  PromotionRebatesComponent, ProductSelectionComponent, PageHeaderComponent],
    standalone: true
})
export class CoreRangeDetailsComponent implements OnInit {
  @ViewChild('productSelection', {static: false}) productSelection: DxPopupComponent;
  @ViewChild('productSelectionPopup', {static: false}) productSelectionComponent: ProductSelectionComponent;
  @ViewChild(DxDataGridComponent, { static: false }) public dataGrid: DxDataGridComponent;
  coreRangeDetailsLoading: boolean = true;
  productDataSource: DataSource;
  parent: string = 'core-range-details'
  key: number = 0;
  header: any;
  rebateNames: RebateNames[] = [];
  columns: any[] = [];
  currencyFormat = { type: 'currency', precision: 2 };
  permissions: boolean = true;
  disabled: boolean = false;
  copyPricing: boolean = false;
  buyingGroups: BuyingGroups[] = [];
  buyingGroupNames: any[] = [];
  showFilterRow: boolean = false;
  private apiUrl: string = environment.baseApiUrl;

  constructor(private crudService: CrudService,
    private router: Router,
    private horizontalMenuService: HorizontalMenuService,
    private costService: CostServiceService) {
      this.coreRangeDetailsLoading = true;
      if(localStorage.getItem('core-range-header') !== null) {
        const header = JSON.parse(localStorage.getItem('core-range-header') || '{}');
        this.header = header;
        this.key = header.id;
      }
      if(this.header.status_type === 'closed') {
        this.disabled = true;
      }
  }
ngOnInit(): void {
  this.loadData();
}
  // contentReadyLoading(event:any){
  //   this.coreRangeDetailsLoading = false; // End loading
  // }
  async loadData()
  {
    this.coreRangeDetailsLoading = true;
    this.copyPricing = false;
    console.log(`Core Range Header`, this.header);
    // Buying groups are loaded BEFORE the rows. The Buying Group column resolves
    // each code to its short name through buyingGroupNames, so that list has to be
    // populated before the grid paints or the first render falls back to raw codes.
    await this.loadBuyingGroups();
    await this.crudService.getData(`${this.apiUrl}core-range-details?core_range_header_id=${this.header.id}`).subscribe((products: any) => {
      const normalizedData = products.data.map((product: any) => ({
        ...product,
        rebated: product.rebated === 1
      }));
      this.productDataSource = new DataSource({
      store: new ArrayStore({
        data: normalizedData,
        key: ['id']
      }),
      filter: [['core_range_header_id', '=', this.key]]
      });
    }, (error: any) => {
      console.log('Error fetching core range details: ', error);
    });
   await this.crudService.getData(environment.baseApiUrl + 'rebates?type=1').toPromise()
        .then((rebateNames: any) => {
          this.rebateNames = rebateNames.data;
          this.addColumn();
          this.coreRangeDetailsLoading = false;
        })
        .catch((error: any) => {
          console.log('Error fetching rebate names: ', error);
      });
  }

  async loadBuyingGroups(): Promise<void>
  {
    try {
      const buyingGroups: any = await this.crudService.getData(`${this.apiUrl}buying-groups`).toPromise();
      this.buyingGroups = [];
      this.buyingGroupNames = [];
      buyingGroups.forEach((buyingGroup: BuyingGroups) => {
        this.buyingGroups.push(buyingGroup);
        this.buyingGroupNames.push({
          id: buyingGroup.id,
          code: buyingGroup.buying_group_code,
          short_name: buyingGroup.short_name
        });
      });
      // Make buyingGroupNames unique
      this.buyingGroupNames = this.buyingGroupNames.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.id === value.id && t.code === value.code)
      );
      console.log('Buying Groups: ', this.buyingGroupNames);
    } catch (error: any) {
      console.log('Error fetching buying groups: ', error);
    }
  }

  /**
   * Friendly label for a buying group code - the short name the client maintains on
   * the Buying Groups settings screen, falling back to the code when none is set.
   *
   * Display only. The code stays the value the tag box holds and posts, because it
   * is what the POS brief store-size mapping, the compliance feed and effectiveness
   * ES banner scoping all match on.
   */
  buyingGroupLabel = (code: string): string =>
  {
    const buyingGroup = this.buyingGroupNames.find((group: any) => group.code === code);
    return buyingGroup?.short_name || code;
  }

  buyingGroupDisplayExpr = (item: any): string =>
  {
    if(item === null || item === undefined) {
      return '';
    }
    // The tag box hands us the item object for a known buying group, but falls back
    // to the bare code for a value with no matching item.
    return typeof item === 'string' ? this.buyingGroupLabel(item) : (item.short_name || item.code);
  }

  /**
   * A core range row carries an array of buying group codes (the API groups the
   * rows and appends each code), so the cell is rendered as a joined list of labels.
   */
  calculateBuyingGroupDisplayValue = (row: any): string =>
  {
    const codes = row?.buying_group_code;
    if(codes === null || codes === undefined) {
      return '';
    }
    return (Array.isArray(codes) ? codes : [codes])
      .filter((code: any) => code !== null && code !== undefined && code !== '')
      .map((code: any) => this.buyingGroupLabel(code))
      .join(', ');
  }

  onRowUpdating(e: any)
  {
    Object.assign(e.oldData, e.newData);
    console.log('Row Updating: ', e);
    const rebateData: any[] = [];
    const keys = Object.keys(e.newData);
    keys.forEach((key: any) => {
      const rebateDetails = this.rebateNames.find((rebate) => rebate.rebate_name === key);
      if(rebateDetails) {
        rebateData.push({
          rebate_id: rebateDetails.id,
          rebate_amount: e.newData[key]
        });
      }
    });
    const data = { ...e.oldData , rebates: [...rebateData] };
    this.coreRangeDetailsLoading = true;
    this.crudService.updateData(`${this.apiUrl}core-range-details`, e.key.id, data)
      .subscribe((result: any) => {
        this.coreRangeDetailsLoading = false;
        if(result.success) {
          if(rebateData.length > 0) {
            const hasRebateValue = this.rebateNames.some((rebate) => e.oldData[rebate.rebate_name] > 0);
            e.oldData.rebated = hasRebateValue;
          }
          notify(result.data, 'success', 200);
        } else {
          notify(result.data, 'error', 500);
        }
      });
  }

  onRowRemoving(e: any)
  {
    this.crudService.deleteData(`${this.apiUrl}core-range-details`, e.key.id)
      .subscribe((result: any) => {
        if(result.success) {
          notify(result.data, 'success', 500);
        } else {
          notify(result.data, 'error', 500);
        }
      })
  }

  calculateGpAmount = (row: Product) =>
  {
    if((row.sell_price ?? 0) > 0) {
      return this.costService.calculateGpAmount(row);
    }
    return 0;
  }

  calculateGpPercent = (row: Product) =>
  {
    if((row.sell_price ?? 0) > 0) {
      return this.costService.calculateGpPercent(row);
    }
    return 0;
  }

  calculateNewCost = (row: Product) =>
  {
    return this.costService.calculateNewCost(row);
  }

  calculateNUCost = (row: Product) =>
  {
    const newCost = this.costService.calculateNewCost(row) || 0;
    return newCost / row.packs_per_carton;
  }

  openProductSelection = (e: any) => {
    this.productSelectionComponent.loadProducts();
    this.productSelection.instance.show();
  }

  closeProductSelection = () => {
    this.productSelection.instance.hide();
  }

  returnToHeader = (e:any) =>{
    this.router.navigate(['/core-range']);
  }

  addColumn() {
    this.columns = [];
    this.rebateNames.forEach((rebate: RebateNames) => {
       this.columns.push({
          dataField: rebate.rebate_name,
          dataType: 'number',
          format: {
            type: 'currency',
            precision: 2
          }
        });
      });
    }

    onEditingStart(e: any) {
      this.rebateNames.forEach((rebate: RebateNames) => {
        if(e.column.dataField === rebate.rebate_name) {
          localStorage.setItem('coreSelectedRebateColumn', rebate.rebate_name);
        }
      });
    }

    onCellPrepared(e: any) {
      if (e.rowType === 'data' && e.data.product_deleted_at) {
        e.cellElement.style.color = "red";
      }
    }

    rebatePopupEvent(e: any){
      const nativeEvent = e.event || e;
      if (nativeEvent.stopPropagation) {
        nativeEvent.stopPropagation();
      }
      this.horizontalMenuService.seteditPromotionRebates(true);
    }

    sanitizeSheetName(name: string): string {
      return name.replace(/[:\\/?*\[\]]/g, '_');
    }

    onExporting(e: any) {
      console.log('Header: ',this.header);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(this.sanitizeSheetName(this.header.range_name));

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
        customizeCell: ({ gridCell, excelCell }) => {
          if(gridCell?.rowType === 'header') {
            excelCell.font = { bold: true };
            excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '6ABDC8' } };
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Core Range ${this.sanitizeSheetName(this.header.range_name)}.xlsx`);
        });
      });
    }

    updateCosts() {
      this.crudService.getData(`${this.apiUrl}update-core-range-costs?core_range_header_id=${this.header.id}&buying_group_id=${this.header.buying_group_id}`).subscribe((result:any) => {
        if(result.success) {
          this.dataGrid.instance.refresh();
          notify({ message: 'Update complete' }, 'success');
        } else {
          notify({ message: 'Update failed' }, 'error');
        }
      }
      );
    }

    openCopySelection = (e: any) => {
      console.log(e);
      this.copyPricing = !this.copyPricing;
      //this.cdr.detectChanges();
    }

    closeCopySelection = () => {
      this.copyPricing = false;
      this.dataGrid.instance.refresh();
    }

    showFilters = () => {
      this.showFilterRow = !this.showFilterRow;
    }

}

export class CoreRangeDetail
{
  id?: number;
  core_range_header_id: number;
  product_id: number;
  product_name: string;
  cost_inc_gst: number;
  sell_price: number;
  standard_price: number;
}
